import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { ContextMenu } from '../../models/context-menu.model';

@Injectable()
export class MenuService {
  private menuState: boolean = true;
  private contextMenuUpdatedSource = new Subject<ContextMenu>();
  contextMenuUpdated$ = this.contextMenuUpdatedSource.asObservable();

  constructor() {
  }

  getMenuState(): boolean {
    return this.menuState;
  }

  setContextMenu(contextMenu?: ContextMenu): void {
    this.contextMenuUpdatedSource.next(contextMenu);
  }

  setMenuState(status: boolean): void {
    this.menuState = status;
  }

  showAnalyticsContextMenu(): void {
    this.setContextMenu(new ContextMenu('Analyses', [
      { name: 'Prévisions d\'usure', icon: 'trending-down', route: 'PkWearForecastPage' },
      { name: 'Santé des lignes', icon: 'pulse', route: 'LinesHealthPage' },
      { name: 'Logigramme décisionnel', icon: 'git-branch', route: 'DecisionTreeSchemaPage' }
    ]));
  }

  showCampaignsContextMenu(): void {
    this.setContextMenu(new ContextMenu('Campagnes', [
      { name: 'Campagnes en cours', icon: 'arrow-dropright-circle', route: 'CampaignInProgressPage' },
      { name: 'Campagnes terminées', icon: 'archive', route: 'CampaignClosedPage' },
    ]));
  }

  showMeasuresContextMenu(): void {
    this.setContextMenu(new ContextMenu('Mesures', [
      { name: 'Tableau des mesures', icon: 'ios-list-box-outline', route: 'MeasureListPage' },
      { name: 'Remplacement de barre', icon: 'construct', route: 'GuidebarReplacementPage', adminOnly: true },
    ]));
  }

  showObservationsContextMenu(): void {
    this.setContextMenu(new ContextMenu('Observations', [
      { name: 'Nouvelles observations', icon: 'alert', route: 'ObservationsPage', params: { observationState: 'NEW' } },
      { name: 'Historique', icon: 'archive', route: 'ObservationsPage', params: { observationState: 'ARCHIVED' } },
    ]));
  }

  showPrioritiesContextMenu(): void {
    this.setContextMenu(new ContextMenu('Priorités', [
      { name: 'Remplacement de barre', icon: 'construct', route: 'ReplacementPrioritiesPage', params: { prioritiesType: 'replacement' } },
      { name: 'Limite d\'aile 1', icon: 'timer', route: 'ReplacementPrioritiesPage', params: { prioritiesType: 'alert-thickness' } }
    ]));
  }

  showSettingsContextMenu(): void {
    this.setContextMenu(new ContextMenu('Paramétrage', [
      { name: 'Types d\'observations', icon: 'eye', route: 'ObservationTypesSettingsPage' },
      { name: 'Configuration PK', icon: 'settings', route: 'PksSettingsPage' },
      { name: 'Seuil de surveillance', icon: 'settings', route: 'WearStateThresholdSettingsPage' }
    ]));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/util/menu.service.ts